module.exports = __webpack_public_path__ + "static/media/bg-img.b42f7c0b.jpg";